import "./index.css";
import * as mhReact from "mhreact";
export default function Spinner(_ref) {
  var isLoading = _ref.isLoading;
  if (isLoading) return mhReact.createElement("span", {
    "class": "spinner"
  });
  return mhReact.createElement("span", null);
}